<template>
  <div>
    <div class="panel" :key="note.id">
      <div class="panel-body">
        <div class="row" style="padding-bottom: 10px">
          <div class="col-xs-3">{{ dateCreated | date($user.date_format_preference) }}</div>
          <div class="col-xs-3">{{ timeCreated }}</div>
        </div>
        <div class="row">
          <div class="col-xs-8"><div v-html="note.text"></div><p class="note-creator">{{ creator }}</p></div>
          <div class="col-xs-4 flex justify-end">
            <ladda-button v-if="!note.pinned" class="btn btn-primary" :click="handlePinNote">
              <i class="fa fa-thumb-tack"></i> Pin
            </ladda-button>
            <ladda-button v-else class="btn btn-primary" :click="handlePinNote">
              <i class="fa fa-thumb-tack"></i> Unpin
            </ladda-button>
            <ladda-button class="margin-l-1 btn btn-primary" :click="handleDeleteNoteCallback">
              <i class="fa fa-trash"></i> Delete
            </ladda-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import moment from 'moment-timezone'
import { alert } from 'utils'

export default {
  props: {
    note: {
      type: Object,
      required: true
    }
  },

  computed: {
    /**
     * Show date created in local time
     */
    dateCreated () {
      return moment.utc(this.note.created_at).local()
    },

    /**
     * Show time created in local time
     */
    timeCreated () {
      return moment.utc(this.note.created_at).local().format('hh:mma')
    },

    creator () {
      if (this.note.user) {
        return ' by ' + this.note.user.first_name + ' ' + this.note.user.last_name
      }
      return ' by unknown'
    }
  },

  methods: {

    handlePinNote () {
      this.$emit('pin', this.note.id)
      return Promise.resolve()
    },

    handleDeleteNoteCallback () {
      const confirmAlertOptions = {
        title: 'Delete Note',
        text: 'Are you sure you want to delete this note?'
      }

      return alert.confirm(confirmAlertOptions)
        .then(() => {
          this.$emit('delete')
        })
    }

  }
}

</script>
